import { useNavigate } from "react-router-dom";
import { accessData, isLogged } from "../helpers/AppConfig";
import AccessDenied from "src/pages/accessdenied/AccessDenied";
import PATHS from "./Paths";

interface ProtectedRouteProps {
  requiredPermissions: string[]; 
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredPermissions, children }) => {
  const navigate = useNavigate();
  const isAuthorized = isLogged();
  const userPermissions = accessData("permissions") || [];
  
  const hasRequiredPermissions = requiredPermissions.some(permission =>
    userPermissions?.includes(permission)
  );

  if (isAuthorized && hasRequiredPermissions) {
    return <>{children}</>;
  } 
  else if (isAuthorized && !hasRequiredPermissions) {
    return <AccessDenied />;
  } 
  else {
    navigate(PATHS.login); 
    return null;
  }
};

export default ProtectedRoute;
